import { useQuery } from '@tanstack/react-query';

import { SearchOptions, SearchService } from '@/generated/api';

export function useSearchManufacturers(
  payload: SearchOptions,
  noTracking = false,
  enabled = true,
) {
  return useQuery({
    queryKey: ['searchManufacturers', payload, noTracking],
    enabled: enabled,
    queryFn: () =>
      SearchService.manufacturerSearchControllerGetManufacturersPost(
        payload,
        noTracking ? 'true' : undefined,
      ),
    refetchOnWindowFocus: false,
  });
}
